// extracted by mini-css-extract-plugin
export default {"rightNavigation":"CarouselRightNavigation_rightNavigation__IPEC5"};